export default "__VITE_ASSET__65a18a2e__"